import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import useStyles from '../makeStyles';

const PromoCodeNotFound = ({ errorMessage }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Typography color="error" className={classes.promoCodeError}>
      {t(`backendErrors.${errorMessage.errorShortCode}`, errorMessage.errorData)}
    </Typography>
  );
};

PromoCodeNotFound.propTypes = {
  errorMessage: PropTypes.shape({
    errorData: PropTypes.shape({}),
    errorShortCode: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
};

export default PromoCodeNotFound;
